// Cálculos do painel de atendimento (modo TV): transforma as respostas da API
// em números prontos para a tela e nos alertas de "o que pede atenção agora".

// A API devolve alguns textos com o acento perdido (ex.: "Atï¿½ 20 minutos").
const CONSERTOS = [
    [/classificaï¿½ï¿½o/gi, 'classificação'],
    [/Atï¿½/g, 'Até'],
    [/Mï¿½dia/g, 'Média'],
];

export function consertarTexto(texto) {
    let t = texto == null ? '' : String(texto);
    CONSERTOS.forEach(([de, para]) => { t = t.replace(de, para); });
    return t;
}

// Números vêm como texto e às vezes com vírgula decimal ("25,4").
export function num(valor) {
    const n = Number(String(valor == null ? '' : valor).replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
}

export function formatarMinutos(minutos) {
    const m = Math.round(num(minutos));
    if (m < 60) return `${m} min`;
    const h = Math.floor(m / 60);
    const resto = m % 60;
    return resto ? `${h}h${String(resto).padStart(2, '0')}` : `${h}h`;
}

export function formatarPercentual(valor) {
    return `${valor > 0 ? '+' : ''}${Math.round(valor)}%`;
}

// Gráficos da API vêm como [ {labels}, {datasets}, {options} ].
function partesGrafico(resposta, chave) {
    const partes = (resposta && resposta[chave]) || [];
    const labels = (partes[0] && partes[0].labels) || [];
    const datasets = (partes[1] && partes[1].datasets) || [];
    return { labels, datasets };
}

// Mapa nome -> valor de um gráfico de barras simples (abertos/finalizados por atendente).
export function contagemPorNome(resposta, chave) {
    const { labels, datasets } = partesGrafico(resposta, chave);
    const dados = (datasets[0] && datasets[0].data) || [];
    const mapa = {};
    labels.forEach((nome, i) => { mapa[String(nome).trim()] = num(dados[i]); });
    return mapa;
}

// Chamados por hora das últimas ~24h. Rótulos "DD HH"; a API acrescenta
// "Fechamento"/"Media" no fim dos rótulos, que não são horas e ficam de fora.
export function montarPorHora(resposta) {
    const { labels, datasets } = partesGrafico(resposta, 'chamadoporhora');
    const serie = (prefixo) => {
        const ds = datasets.find((d) => consertarTexto(d.label).toLowerCase().startsWith(prefixo));
        return (ds && ds.data) || [];
    };
    const abertura = serie('abertura');
    const fechamento = serie('fechamento');
    const media = serie('média');

    const horas = [];
    labels.forEach((rotulo, i) => {
        const m = /^(\d{2}) (\d{2})$/.exec(String(rotulo).trim());
        if (!m) return;
        horas.push({
            dia: m[1],
            hora: Number(m[2]),
            abertos: num(abertura[i]),
            fechados: num(fechamento[i]),
            media: num(media[i]),
        });
    });
    const hoje = horas.length ? horas[horas.length - 1].dia : null;
    horas.forEach((h) => { h.hoje = h.dia === hoje; });
    return horas;
}

// Ritmo do dia: chamados abertos hoje x o que a média histórica previa até
// este horário. A hora corrente entra proporcional aos minutos já passados.
export function ritmoDoDia(horas, agora = new Date()) {
    const deHoje = horas.filter((h) => h.hoje);
    if (!deHoje.length) return null;
    const fracaoHora = agora.getMinutes() / 60;
    let esperado = 0;
    let realizado = 0;
    deHoje.forEach((h, i) => {
        const corrente = i === deHoje.length - 1;
        esperado += corrente ? h.media * fracaoHora : h.media;
        realizado += h.abertos;
    });
    if (esperado < 1) return null;
    return {
        realizado,
        esperado: Math.round(esperado),
        variacao: ((realizado - esperado) / esperado) * 100,
    };
}

// Chamados do dia: linhas [chamado, abertura, minutos, status, responsável, banco, grupo WhatsApp].
// A API manda abertos e finalizados juntos; a fila fica só com os que não foram finalizados.
const finalizado = (l) => /^finaliz/i.test(String(l[3]).trim());

export function montarFila(linhas) {
    return montarChamados((Array.isArray(linhas) ? linhas : []).filter((l) => !finalizado(l)));
}

// Finalizados hoje que mais demoraram (minutos = duração do atendimento).
export function montarMaisDemorados(linhas, quantos = 6) {
    return montarChamados((Array.isArray(linhas) ? linhas : []).filter(finalizado)).slice(0, quantos);
}

// Tempo médio (min) dos chamados finalizados hoje por um responsável (ex.: o LUK).
export function tempoMedioFinalizados(linhas, login) {
    const minutos = (Array.isArray(linhas) ? linhas : [])
        .filter((l) => finalizado(l) && String(l[4]).trim().toUpperCase() === String(login).toUpperCase())
        .map((l) => num(l[2]));
    return minutos.length ? minutos.reduce((a, b) => a + b, 0) / minutos.length : null;
}

function montarChamados(linhas) {
    return linhas
        .map((l) => ({
            chamado: l[0],
            abertura: l[1],
            minutos: num(l[2]),
            status: consertarTexto(l[3]),
            responsavel: consertarTexto(l[4]),
            banco: consertarTexto(l[5]),
            cliente: consertarTexto(l[6]).replace(/\s*\+\s*Lukos\s*$/i, '').replace(/^Lukos\s*\+\s*/i, '') || consertarTexto(l[5]),
        }))
        .sort((a, b) => b.minutos - a.minutos);
}

export const LIMITE_ATENCAO_MIN = 30;
export const LIMITE_ATRASO_MIN = 60;

export function situacaoIdade(minutos) {
    if (minutos >= LIMITE_ATRASO_MIN) return 'critico';
    if (minutos >= LIMITE_ATENCAO_MIN) return 'serio';
    return 'normal';
}

// Atendentes online: linhas [login, online, tempo em chamado, qtde, pontuação],
// enriquecidas com abertos agora, finalizados hoje e a ordem da distribuição.
export function montarAtendentes(linhas, abertosPorNome, finalizadosPorNome, proximos) {
    const ordemProximos = String(proximos || '')
        .split(',')
        .map((n) => n.trim().toUpperCase())
        .filter(Boolean);
    return (Array.isArray(linhas) ? linhas : []).map((l) => {
        const login = consertarTexto(l[0]).trim();
        const posicao = ordemProximos.indexOf(login.toUpperCase());
        return {
            login,
            online: num(l[1]),
            tempoChamado: num(l[2]),
            qtde: num(l[3]),
            pontuacao: num(l[4]),
            abertos: abertosPorNome[login] || 0,
            finalizados: finalizadosPorNome[login] || 0,
            proximo: posicao >= 0 ? posicao + 1 : null,
        };
    });
}

// Tipos: [{qtde, TipoChamado, TempoMedio}], do maior volume para o menor.
export function montarTipos(lista) {
    return (Array.isArray(lista) ? lista : [])
        .map((t) => ({ tipo: consertarTexto(t.TipoChamado), qtde: num(t.qtde), tempoMedio: num(t.TempoMedio) }))
        .sort((a, b) => b.qtde - a.qtde);
}

// Clientes do dia: [[banco, qtde]].
export function montarClientes(linhas) {
    return (Array.isArray(linhas) ? linhas : [])
        .map((l) => ({ banco: consertarTexto(l[0]), qtde: num(l[1]) }))
        .sort((a, b) => b.qtde - a.qtde);
}

// Duração dos chamados do dia, em faixas (até 20, 40, 60 min, mais de 1h).
export function montarDuracao(resposta) {
    const { labels, datasets } = partesGrafico(resposta, 'ChamadoPorTempo');
    const dados = (datasets[0] && datasets[0].data) || [];
    return labels.map((rotulo, i) => ({ faixa: consertarTexto(rotulo), qtde: num(dados[i]) }));
}

// Alertas em ordem de gravidade. Cada um: { nivel, icone, titulo, detalhe }.
// nivel: critico | serio | atencao | info | bom
export function montarAlertas({ resumo, fila, ritmo, clientes, tipos }) {
    const alertas = [];
    const abertos = num(resumo.chamadosEmAberto);
    const online = num(resumo.atendentesON);

    if (online > 0 && abertos > online) {
        alertas.push({
            nivel: 'critico', icone: 'groups',
            titulo: 'Fila maior que a equipe',
            detalhe: `${abertos} chamados abertos para ${online} atendentes online`,
        });
    } else if (online === 0 && abertos > 0) {
        alertas.push({
            nivel: 'critico', icone: 'person_off',
            titulo: 'Ninguém online',
            detalhe: `${abertos} chamados abertos sem atendente disponível`,
        });
    }

    const atrasados = fila.filter((c) => c.minutos >= LIMITE_ATRASO_MIN);
    if (atrasados.length) {
        const maisAntigo = atrasados[0];
        alertas.push({
            nivel: 'critico', icone: 'timer_off',
            titulo: atrasados.length === 1
                ? 'Chamado aberto há mais de 1 hora'
                : `${atrasados.length} chamados abertos há mais de 1 hora`,
            detalhe: `Mais antigo: #${maisAntigo.chamado} há ${formatarMinutos(maisAntigo.minutos)} · ${maisAntigo.responsavel} · ${maisAntigo.cliente}`,
        });
    } else if (fila.length && fila[0].minutos >= LIMITE_ATENCAO_MIN) {
        const c = fila[0];
        alertas.push({
            nivel: 'serio', icone: 'hourglass_bottom',
            titulo: `Chamado aberto há ${formatarMinutos(c.minutos)}`,
            detalhe: `#${c.chamado} · ${c.responsavel} · ${c.cliente}`,
        });
    }

    const zap = num(resumo.filaZAP);
    if (zap >= 200) {
        alertas.push({ nivel: 'critico', icone: 'chat', titulo: 'Fila do WhatsApp travando', detalhe: `${zap} mensagens aguardando envio` });
    } else if (zap >= 100) {
        alertas.push({ nivel: 'serio', icone: 'chat', titulo: 'Fila do WhatsApp crescendo', detalhe: `${zap} mensagens aguardando envio` });
    }

    if (ritmo && ritmo.variacao >= 20) {
        alertas.push({
            nivel: 'atencao', icone: 'trending_up',
            titulo: `Movimento ${formatarPercentual(ritmo.variacao)} acima do normal`,
            detalhe: `${ritmo.realizado} chamados hoje; o normal até este horário seria ${ritmo.esperado}`,
        });
    }

    const clienteTop = clientes[0];
    if (clienteTop && clienteTop.qtde >= 3) {
        alertas.push({
            nivel: 'atencao', icone: 'repeat',
            titulo: `${clienteTop.banco}: ${clienteTop.qtde} chamados hoje`,
            detalhe: 'Vale ver se é o mesmo problema voltando',
        });
    }

    const semClassificacao = tipos.find((t) => /sem classifica/i.test(t.tipo));
    if (semClassificacao && semClassificacao.qtde >= 5) {
        alertas.push({
            nivel: 'info', icone: 'label_off',
            titulo: `${semClassificacao.qtde} chamados sem classificação`,
            detalhe: 'Sem o tipo, os indicadores por tipo ficam incompletos',
        });
    }

    const tiposRelevantes = tipos.filter((t) => t.qtde >= 3 && !/sem classifica/i.test(t.tipo));
    if (tiposRelevantes.length > 1) {
        const lento = tiposRelevantes.reduce((a, b) => (b.tempoMedio > a.tempoMedio ? b : a));
        alertas.push({
            nivel: 'info', icone: 'slow_motion_video',
            titulo: `Mais demorado: ${lento.tipo}`,
            detalhe: `${lento.tempoMedio} min em média em ${lento.qtde} chamados`,
        });
    }

    if (ritmo && ritmo.variacao <= -20) {
        alertas.push({
            nivel: 'bom', icone: 'trending_down',
            titulo: `Movimento ${formatarPercentual(ritmo.variacao)} abaixo do normal`,
            detalhe: `${ritmo.realizado} chamados hoje; o normal até este horário seria ${ritmo.esperado}`,
        });
    }

    if (!alertas.some((a) => a.nivel === 'critico' || a.nivel === 'serio')) {
        alertas.unshift({ nivel: 'bom', icone: 'check_circle', titulo: 'Fila sob controle', detalhe: 'Nenhum chamado parado e equipe dando conta' });
    }
    return alertas;
}
